import Job1 from '../../Assets/Home/Job1.png';
import { APPLY_URL, BASE_URL, MEDIA_URL2 } from '../../axios';
import CareerForm from '../../Pages/CareerForm';

const PositionCards = ({ data }) => {

  const locationicon = MEDIA_URL2 + 'Career/location.svg';
  const timeicon = MEDIA_URL2 + 'Career/time.svg';
  const experienceicon = MEDIA_URL2 + 'Career/experience.svg';

  const { id, position_name, job_type, location, experience, department_name, sub_company_name, description } = data;

  return (
    <div
      className="flex flex-col hover:bg-[#b796f822] hover:-translate-y-1 gap-4 p-6 border rounded-xl cursor-pointer shadow-md duration-300 hover:shadow-lg bg-white"
      style={{ minHeight: "300px" }}
    >
      {/* Card Header */}
      <div className="flex justify-between items-center w-full">
        <p className="text-lg md:text-2xl font-semibold text-gray-800">
          {position_name}
        </p>

        <a
          href={`${APPLY_URL}/${id}/`}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#8364c3] flex items-center justify-center rounded-md px-4 py-2 text-sm md:text-lg text-white hover:bg-[#6f52b3] duration-300"
        >
          Apply Now
        </a>
      </div>

      {/* Job Details */}
      <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600">
        <div className="flex items-center gap-1">
          <img src={locationicon} alt="location" className="w-4 md:w-5" />
          <span>{location}</span>
        </div>

        <div className="flex items-center gap-1">
          <img src={timeicon} alt="job type" className="w-4 md:w-5" />
          <span>{job_type}</span>
        </div>

        <div className="flex items-center gap-1">
          <img src={experienceicon} alt="experience" className="w-4 md:w-5" />
          <span>{experience}</span>
        </div>
      </div>

      {/* Additional Information */}
      <div className="flex flex-wrap items-center gap-4 text-sm font-semibold text-gray-800">
        <p className="bg-[#6e7fa65d] hover:bg-[#8364c3] hover:text-white duration-300 rounded-md px-4 py-2">
          {department_name}
        </p>

        <p className="bg-[#6e7fa65d] hover:bg-[#8364c3] hover:text-white duration-300 rounded-md px-4 py-2">
          {sub_company_name}
        </p>
      </div>

      {/* Description */}
      <p className="text-sm text-gray-600 line-clamp-3">
        {description}
      </p>
    </div>
  );
};

export default PositionCards;